import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function SEOContent() {
  const { t } = useTranslation();
  const displayArticles = articles.slice(0, 9);

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-5 py-2 text-xs font-semibold text-foreground-600 border border-foreground-300/50 rounded-full mb-6 uppercase tracking-wider">
            {t('seo.section_tag')}
          </span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
            <strong>{t('seo.title')}</strong>
            <br />
            <span className="text-primary-500">{t('seo.subtitle')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artikel/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-300 hover:border-primary-300/50 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 backdrop-blur-sm text-primary-600 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{article.readingTime}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-500 group-hover:gap-2 transition-all">
                    {t('button.read_more')}
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}